import React from 'react';
import './PostsListView.css';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import { ButtonText, ButtonReturn } from '../ButtonSquare';
import TitleHeader from '../TitleHeader';
import PostPreview from '../PostPreview';

const PostsListView = (props) => {
  const {
    data,
    theme,
    title,
    subtitle,
    titleColor,
    subtitleColor,
    activeFilter,
    filters,
  } = props;
  const url = theme === 'dark' ? 'references' : 'blog';
  const postPreviewDivs = [];
  if (data.allDatoCmsArticle) {
    const {
      allDatoCmsArticle: {
        edges: articles,
      },
    } = data;
    if (articles) {
      articles.forEach((element) => {
        const article = element.node;
        postPreviewDivs.push(<PostPreview
          pictureSrc={article.pictures[0].sizes}
          title={article.title}
          subtitle={article.subtitle}
          link={`/${article.slug}`}
          theme={theme === 'dark'
            ? 'light'
            : 'dark'}
        />);
      });
    }
  }
  const filtersDivs = [];
  filters.forEach((filter) => {
    filtersDivs.push(
      <ButtonText
        active={activeFilter === filter.value}
        theme={theme === 'dark'
          ? 'light'
          : 'dark'}
        link={`/${url}-${filter.value}`}
      >
        {filter.title}
      </ButtonText>,
    );
  });
  return (
    <div className={`postlistview postlistview_background_${theme}`}>
      <div className="postlistview_return_button">
        <ButtonReturn theme={theme === 'dark'
          ? 'light'
          : 'dark'}
        />
      </div>
      <TitleHeader
        title={title}
        titleColor={titleColor}
        subtitle={subtitle}
        subtitleColor={subtitleColor}
      />
      <div className="postlistview_filters">
        {filtersDivs}
      </div>
      <div className="postlistview_posts">
        {postPreviewDivs}
      </div>
    </div>
  );
};

PostsListView.defaultProps = {
  data: {},
  theme: 'light',
  activeFilter: '',
  filters: [],
};

PostsListView.propTypes = {
  data: PropTypes.shape({
    allDatoCmsArticle: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        pictures: PropTypes.array, title: PropTypes.string, subtitle: PropTypes.string, slug: PropTypes.string,
      })),
    }),
  }),
  theme: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  subtitleColor: PropTypes.string.isRequired,
  activeFilter: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.shape({ title: PropTypes.string, value: PropTypes.string })),
};

export default PostsListView;



// WEBPACK FOOTER //
// ./src/components/PostsListView/PostsListView.jsx